import { NavLink, Outlet } from 'react-router-dom'
import { CONNECTS_TABS } from '@/components/connects/constants'
import { cn } from '@/utils/cn'

export function ConnectsLayout() {
  return (
    <div className="-m-4 flex min-h-[calc(100vh-4rem)] flex-col lg:-m-6">
      <div className="border-b border-border bg-card px-4 pt-4 lg:px-6">
        <h1 className="text-xl font-bold tracking-tight">Connects</h1>
        <nav
          className="-mb-px mt-4 flex gap-1 overflow-x-auto scrollbar-thin"
          aria-label="Connects tabs"
        >
          {CONNECTS_TABS.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                cn(
                  'shrink-0 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors',
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  )
}
